<template>
  <div class="relative flex items-center justify-center customPopup2 fixed w-full h-full z-[21474830004] left-0 top-0"
    v-show="state.upgrade.show" :class="state.upgrade.show ? 'active' : ''" id="tail">
    <div id="modal_1"
      class="flex overflow-auto fixed top-0 z-50 items-start w-full h-screen bg-gray-800 bg-opacity-50">
      <div class="flex justify-center items-center mx-auto w-full max-w-6xl md:py-20 md:px-20 xs-max:relative">
        <div
          class="flex relative flex-col justify-center items-center px-4 py-2 pt-5 pb-8 w-full max-w-screen-lg bg-white border-t-8 border-yellow-600 shadow-lg md:w-auto md:py-14 lg:px-12 xl:px-16">
          <div class="w-full modal-header">
            <div class="flex justify-between mb-2 space-x-3 w-full text-sm font-semibold">
              <div class="item">Add to Cart</div>
              <div class="text-center item sm:text-left">Upgrade Options</div>
              <div class="text-right item">Secure Checkout</div>
            </div>
            <div class="mb-3 w-full progress progress-striped active">
              <div class="progress-bar progress-bar-success" :class="modal.crosssell.show ? 'w-3/4' : 'w-1/2'">
                <span>&nbsp;</span>
              </div>
            </div>
          </div>
          <!-- modal body 1 start -->
          <div class="w-full modal-body" v-show="modal.upsell.show">
            <div class="py-2 w-full text-center bg-gray-100 border border-gray-300" role="banner">
              <p class="m-0 text-lg lg:text-lg xl:text-xl" v-text="state.upgrade.UpSell.PreHeader"></p>
              <p class="px-2 m-0 mx-auto w-full text-lg font-bold text-center uppercase opacity-75 md:w-4/5 sm:text-2xl md:text-3xl lg:text-4xl font-ww-medium"
                v-text="state.upgrade.UpSell.Header"></p>
            </div>
            <div class="flex items-center px-0 mt-4 space-x-4 md:space-x-8">
              <div class="h-auto item">
                <h3 role="main"
                  class="text-2xl font-semibold leading-7 text-left text-gray-800 lg:text-3xl lg:leading-9">
                  Lucky You!
                </h3>
                <div data-body-copy class="grid overflow-hidden grid-cols-3 gap-2 sm:grid-cols-8">
                  <!-- You've found our
                  <span class="italic">New Customer Special</span> - our
                  biggest savings anywhere in our store. -->
                  <p class="col-span-2 col-start-1 row-start-1 mt-2 text-base font-normal text-justify sm:col-span-6 sm:text-xl"
                    v-text="state.upgrade.UpSell.SubHeader">
                  </p>
                  <div class="flex col-span-2 row-start-1 items-center sm:col-start-7 sm:col-span-2 sm:row-span-2 item">
                    <img class="mx-auto sm:w-40" loading="lazy" :src="state.upgrade.UpSell.Image" />
                  </div>
                </div>
              </div>
            </div>
            <div class="space-y-3 w-full text-center md:space-y-4">
              <a @click="setChoice(true)" class="cursor-pointer btn--special md-max:!px-4">Yes!
                Upgrade My Savings
                <svg class="absolute inset-y-0 right-4 my-auto w-auto h-2.5 md:right-6 lg:h-4 xl:h-auto"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 29"
                  width="16px" height="29px">
                  <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                    d="M15.704,15.145 L2.146,28.703 C1.789,29.060 1.211,29.060 0.854,28.703 C0.498,28.347 0.498,27.769 0.854,27.412 L13.767,14.499 L0.854,1.587 C0.498,1.231 0.498,0.652 0.854,0.296 C1.211,-0.061 1.789,-0.061 2.146,0.296 L15.704,13.854 C16.060,14.211 16.060,14.788 15.704,15.145 Z">
                  </path>
                </svg>
              </a>
            </div>
            <a @click="setChoice(false)" href="javascript:void(0)"
              class="block text-base leading-none text-center text-gray-800 underline border-b border-transparent focus:outline-none">No
              thanks, I'll pass on this one-time offer</a>
            <button @click="setChoice(false)"
              class="absolute top-0 right-4 text-gray-800 cursor-pointer md:top-4 lg:top-6 lg:right-6 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
              aria-label="close">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round"
                  stroke-linejoin="round"></path>
                <path d="M6 6L18 18" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg>
            </button>
          </div>
          <!-- modal body 1 end -->
          <!-- modal body 2 start -->
          <div class="w-full modal-body" v-show="modal.crosssell.show">
            <div class="py-2 w-full text-center bg-gray-100 border border-gray-300" role="banner">
              <h3
                class="px-2 m-0 mx-auto text-lg font-bold text-center uppercase opacity-75 sm:text-2xl md:text-3xl lg:text-3xl font-ww-medium"
                v-text="state.upgrade.CrossSell.Header"></h3>
            </div>
            <div data-body-copy class="grid overflow-hidden grid-cols-3 gap-2 sm:grid-cols-8">
              <p class="col-span-2 col-start-1 row-start-1 mt-2 text-base font-normal text-justify sm:col-span-6 sm:text-xl"
                v-text="state.upgrade.CrossSell.Body">
              </p>
              <p class="col-span-3 row-start-2 mt-2 text-base font-normal text-justify sm:col-start-1 sm:row-start-2 sm:col-span-6 sm:text-xl"
                v-html="state.upgrade.CrossSell.PricenSave">
              </p>
              <div class="flex col-span-2 row-start-1 items-center sm:col-start-7 sm:col-span-2 sm:row-span-2 item">
                <img class="mx-auto sm:w-40" loading="lazy" :src="state.upgrade.CrossSell.Image" />
              </div>
            </div>
            <div class="space-y-3 w-full text-center md:space-y-4">
              <a @click="setChoice(true)" data-add-upgrade-bundle class="cursor-pointer btn--special md-max:!px-4">Yes!
                Upgrade My Order
                <svg class="absolute inset-y-0 right-4 my-auto w-auto h-2.5 md:right-6 lg:h-4 xl:h-auto"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 29"
                  width="16px" height="29px">
                  <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                    d="M15.704,15.145 L2.146,28.703 C1.789,29.060 1.211,29.060 0.854,28.703 C0.498,28.347 0.498,27.769 0.854,27.412 L13.767,14.499 L0.854,1.587 C0.498,1.231 0.498,0.652 0.854,0.296 C1.211,-0.061 1.789,-0.061 2.146,0.296 L15.704,13.854 C16.060,14.211 16.060,14.788 15.704,15.145 Z">
                  </path>
                </svg>
              </a>
            </div>
            <a @click="setChoice(false)" data-add-default-final href="javascript:void(0)"
              class="block text-sm leading-none text-center text-gray-800 underline border-b border-transparent focus:outline-none">
              No thanks, I'll pass on this opportunity to try these three roasts
              at a big discount…
            </a>
            <button @click="setChoice(false)"
              class="absolute top-6 right-6 text-gray-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
              aria-label="close">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round"
                  stroke-linejoin="round"></path>
                <path d="M6 6L18 18" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['state', 'modal', 'runEngine', 'bonusItemsConfig']);
const { state, modal, runEngine, bonusItemsConfig } = toRefs(props);
const trackEvent = inject("trackEvent");

// Local state to track acceptance
const choices = ref({
  upsellAccepted: false,
  crossSellAccepted: false
});

const setChoice = (accepted) => {
  if (modal.value.upsell.show) {
    // Handle Upsell choice
    choices.value.upsellAccepted = accepted;

    trackEvent({
      event: "experiment_event",
      label: "Upsell Modal",
      action: accepted ? "Accepted Upsell" : "Declined Upsell"
    });

    if (state.value.upgrades.CrossSellOffer && state.value.upgrades.CrossSellOffer.VariantId) {
      modal.value.upsell.show = false;
      modal.value.crosssell.show = true;
    } else {
      proceedToCheckout();
    }

  } else if (modal.value.crosssell.show) {
    // Handle CrossSell choice
    choices.value.crossSellAccepted = accepted;

    trackEvent({
      event: "experiment_event",
      label: "CrossSell Modal",
      action: accepted ? "Accepted CrossSell" : "Declined CrossSell"
    });

    proceedToCheckout();
  }
};

const proceedToCheckout = () => {
  let checkoutItems = [];
  const cartTransformData = {};

  const originalItem = state.value.regular;
  const upgradeItem = state.value.upgrade;

  // Get pack data for cart transform
  const activeItems = state.value.items;
  const activeIndex = state.value.active;
  const variant = activeItems[activeIndex.items]?.Variants[activeIndex.variants];
  const originalPack = variant?.Pack[activeIndex.packs];
  const upgradedPack = variant?.Pack.find(p =>
    p.PackSize === `x${parseInt(originalPack?.PackSize?.replace('x', '') || 0) * 2}`
  ) || originalPack;

  let finalPackQty = 0;
  let mainItem = null;
  let mainVariantId = null;

  // 1. Prepare Main Item (determine qty and object)
  if (choices.value.upsellAccepted) {
    finalPackQty = parseInt(upgradeItem.quantity);
    mainVariantId = upgradeItem.varID;
    mainItem = {
      id: upgradeItem.varID,
      quantity: upgradeItem.quantity,
      packName: upgradeItem.pack,
      coupon: upgradeItem.Coupon
    };

    if (upgradedPack) {
      cartTransformData[upgradeItem.varID] = {
        price: upgradedPack.UnitPrice,
        storefrontTitle: upgradedPack.StorefrontTitle || ''
      };
    }
  } else {
    finalPackQty = parseInt(originalItem.quantity);
    mainVariantId = originalItem.varID;
    mainItem = {
      id: originalItem.varID,
      quantity: originalItem.quantity,
      packName: originalItem.pack,
      coupon: originalItem.Coupon
    };

    if (originalPack) {
      cartTransformData[originalItem.varID] = {
        price: originalPack.UnitPrice,
        storefrontTitle: originalPack.StorefrontTitle || ''
      };
    }
  }

  // 2. Add Bonus Items (FIRST in array) — using cart transform properties instead of discount codes
  if (bonusItemsConfig?.value?.enabled) {
    const bonusItems = bonusItemsConfig.value.getItemsForPack(finalPackQty);

    for (const bonusItem of bonusItems) {
      const bonusLineItem = {
        id: bonusItem.variantId,
        quantity: bonusItem.quantity,
      };

      // Build line-level attributes for cart transform
      const attrs = [];

      // _ctf_prc: price override (defaults to "0" for free items)
      attrs.push({
        key: '_ctf_prc',
        value: String(bonusItem.price ?? 0)
      });

      // _ctf_ttl: storefront title override
      if (bonusItem.title) {
        attrs.push({
          key: '_ctf_ttl',
          value: bonusItem.title
        });
      }

      // _ctf_req_prd: required parent product guard
      // Uses the main product variant ID as the required product if requiredProduct flag is set
      if (bonusItem.requiredProduct) {
        const parentVariantId = typeof bonusItem.requiredProduct === 'string'
          ? bonusItem.requiredProduct
          : String(mainVariantId);
        attrs.push({
          key: '_ctf_req_prd',
          value: JSON.stringify({ i: parentVariantId, q: 1 })
        });
      }

      bonusLineItem.attributes = attrs;
      checkoutItems.push(bonusLineItem);
    }
  }

  // 3. Add CrossSell Item (SECOND in array)
  if (choices.value.crossSellAccepted && modal.value.crosssell.variantId) {
    checkoutItems.push({
      id: modal.value.crosssell.variantId,
      quantity: 1,
    });
  }

  // 4. Add Main Item (LAST in array)
  if (mainItem) {
    checkoutItems.push(mainItem);
  }

  runEngine.value.checkoutWithItems(checkoutItems, trackEvent, cartTransformData);
};

</script>

<style scoped>
@import "@/modal.css";
</style>
